
import state from './companyState.js'
import mutations from './companyMutations.js'
import actions from './companyAction.js'
import getters from './companyGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

